<template>
    <access-table data-u-r-l="/api/management/v1/access"/>
</template>
<script>
    import AccessTable from '@/views/Access/AccessTable'
    export default {
        components: { AccessTable }
    }
</script>
